import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FeatureDescription from "../../../../visComponents/featureDescription";
import FeatureSubDescription from "../../../../visComponents/featureSubDescription";
import {getAvailableFeatureContent, getDbFeatureProperty} from "../../lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";


const LookFeatureInfoContent = (props) => {

  const {lookActiveFeature, intl, isLixil} = props;
  const availableFeatureContent = getAvailableFeatureContent(lookActiveFeature);

  const [activeTitle, setActiveTitle] = useState(availableFeatureContent.length ? availableFeatureContent[0] : "description");

  useEffect(() => {
    const availableFeatureContent = getAvailableFeatureContent(lookActiveFeature);
    setActiveTitle(availableFeatureContent.length ? availableFeatureContent[0] : "description");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature])

  const getContent = (titleKey) => {
    switch (titleKey) {
      case "description":
        return <FeatureDescription feature={lookActiveFeature}/>
      case "features":
        return <FeatureSubDescription feature={lookActiveFeature}/>
      default:
        // return "The GROHE Bau Cosmopolitan E Touchless Electronic Faucet is a common-sense solution for a safer, more hygienic bathroom experience. Sleek, modern design has a precise infrared sensor that detects hand movement and turns the water on automatically without touching the faucet. Faucet turns off automatically when hands are no longer detected, ensuring water runs only when needed, and making it both eco-friendly and economical.\n" +
        //   "                  Featuring renowned German engineering, this touchless cold-water faucet incorporates GROHE Zero, an inner channel that protects water from contact with lead and nickel. In addition, GROHE EcoJoy provides superior efficiency, and a long-life battery ensures dependable performance."
        return null
    }
  }

  const handleChange = (panel) => (event, isExpanded) => {
    if (IS_PRODUCT_JOURNEY) {
      Analytics.sendClickEvent(
        isExpanded
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureInfoContentAccordionOpen + panel
          : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureInfoContentAccordionClose + panel
      );
    } else {
      Analytics.sendClickEvent(
        isExpanded
          ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureInfoContentAccordionOpen + panel
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureInfoContentAccordionClose + panel
      );
    }
    setActiveTitle(isExpanded ? panel : false);
  };

  let lixilURL = "";
  if (lookActiveFeature.dbFeature[getDbFeatureProperty("lixilVariantUrl")] && isLixil) {
    lixilURL = decodeURIComponent(lookActiveFeature.dbFeature[getDbFeatureProperty("lixilVariantUrl")]);
  }

  const openNewTab = () => {
    Analytics.sendClickEvent(IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureInfoContentFeatureLink + lixilURL
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureInfoContentFeatureLink + lixilURL
    );
    Analytics.sendClickEvent();
    window.open(lixilURL, "_blank");
  }

  return (
    <div className="lk-info">
      <ul className="lk-info__list">
        {availableFeatureContent.map(infoKey => {
          return (
            <li className="lk-info__list-item" key={infoKey}>
              <Accordion expanded={activeTitle === infoKey} onChange={handleChange(infoKey)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-label={intl.formatMessage({id:"tooltip.editLook"})}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="lk-info__header"
                >
                  <span className="lk-info__header-title"><FormattedMessage id={"look.feature.info." + infoKey}/></span>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="lk-info__content">
                    {getContent(infoKey)}
                  </div>
                </AccordionDetails>
              </Accordion>
            </li>
          )
        })}
      </ul>
      {lixilURL ? (
        <div className="lk-info__footer">
          <span className="lk-info__footer-text"><FormattedMessage id="look.feature.info.footer.text"/></span>
          <span className="lk-info__footer-link" onClick={openNewTab}><FormattedMessage id="look.feature.info.footer.link"/></span>
        </div>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, moreInfoOpened, moreInfoContent} = store.lookState;
  const {isLixil} = store.fabricatorState;
  return {
    lookActiveFeature,
    moreInfoOpened,
    moreInfoContent,
    isLixil,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureInfoContent)
)
